'use client';

import { createContext } from 'react';

export const GoogleMapsKeyContext = createContext(process.env.NEXT_PUBLIC_GOOGLE_MAPS_KEY ?? '');
